const Android = (props) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 106.23 122.88"
      height={props.height}
    >
      {/* <defs></defs>
      <title>android-robot-bot</title> */}
      <path
        style={{ fill: "#a4c639" }}
        d="M86.29,39c0-11-6.33-20.66-15.79-26l5.23-9.43A2.37,2.37,0,0,0,74.8.3h0a2.37,2.37,0,0,0-3.22.92L66.22,10.9a35.84,35.84,0,0,0-26.2,0L34.65,1.22A2.36,2.36,0,0,0,31.43.3h0a2.36,2.36,0,0,0-.92,3.22L35.74,13C26.27,18.34,20,28,20,39Zm11.2,0h0a8.74,8.74,0,0,1,8.74,8.75v31a8.74,8.74,0,0,1-8.74,8.75h0a8.75,8.75,0,0,1-8.75-8.75v-31A8.75,8.75,0,0,1,97.49,39ZM8.75,39h0a8.75,8.75,0,0,1,8.75,8.75v31a8.75,8.75,0,0,1-8.75,8.75h0A8.75,8.75,0,0,1,0,78.77v-31A8.75,8.75,0,0,1,8.75,39ZM49.47,97.73v16.4a8.75,8.75,0,0,1-8.75,8.75h0A8.74,8.74,0,0,1,32,114.13V97.73H28a8,8,0,0,1-8-8V41.63H86.29V89.71a8,8,0,0,1-8,8h-4v16.4a8.75,8.75,0,0,1-8.75,8.75h0a8.75,8.75,0,0,1-8.75-8.75V97.73Z"
      />
      <path
        style={{ fill: "#fff" }}
        d="M39.26,24.09a1.46,1.46,0,1,0-1.45,1.46,1.45,1.45,0,0,0,1.45-1.46Z"
      />
      <path
        style={{ fill: "#fff" }}
        d="M38,24.09a.15.15,0,0,0,0-.1h0a.18.18,0,0,0-.21,0,.18.18,0,0,0,0,.1.14.14,0,0,0,.15.15.18.18,0,0,0,.1,0,.15.15,0,0,0,0-.11Zm1.81-2h0a2.76,2.76,0,0,1,0,3.91,2.78,2.78,0,0,1-3.92,0h0a2.77,2.77,0,1,1,3.91-3.92Z"
      />
      <path
        style={{ fill: "#fff" }}
        d="M69.89,24.09a1.46,1.46,0,1,0-1.46,1.46,1.46,1.46,0,0,0,1.46-1.46Z"
      />
      <path
        style={{ fill: "#fff" }}
        d="M68.57,24.09a.15.15,0,0,0,0-.1h0a.18.18,0,0,0-.21,0,.18.18,0,0,0,0,.1.14.14,0,0,0,.15.15.18.18,0,0,0,.1,0,.15.15,0,0,0,0-.11Zm1.81-2h0a2.77,2.77,0,0,1-3.92,3.91h0a2.77,2.77,0,1,1,3.91-3.92Z"
      />
    </svg>
  );
};

export default Android;
